import { useMutation, useQueryClient } from '@tanstack/react-query';
import { tradesService } from '@/services/trades/trades-service';
import { invalidateTradeAndPoolCaches } from './invalidate-trade-caches';

export const useTerminateTrade = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, actualSettlementDate, reason }: { id: number; actualSettlementDate?: string; reason?: string }) =>
      tradesService.terminate(id, actualSettlementDate, reason),
    onSuccess: () => {
      // LR-586: cancelling a rejected trade takes its cash out of the pool.
      invalidateTradeAndPoolCaches(queryClient);
    },
  });
};
